import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '@/hooks/useApi/useFetchInteracMoneyRequestTransaction';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
} & Omit<ComponentProps<typeof InteracMoneyRequestTransactionInfo>, 'transaction' | 'Notes'>;

export default function InteracMoneyRequestTransactionContainer({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
  ...props
}: TransactionProps) {
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { interacMoneyRequestTransaction, fetchInteracMoneyRequestTransaction } =
    useFetchInteracMoneyRequestTransaction({ bearer: jwt });

  useEffect(() => {
    blockingLoader.show();

    fetchInteracMoneyRequestTransaction(TransactionID)
      .catch((error) => {
        // Not returned: the dialog's promise settles on dismissal, and the loader must drop before that.
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred'));
      })
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = interacMoneyRequestTransaction;

  return (
    <div>
      {transaction && (
        <InteracMoneyRequestTransactionInfo
          transaction={transaction}
          Notes={Notes || ''}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
